import { rgba, shade } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  padding: 30px;
  min-width: 350px;

  border-radius: 10px;
  background: #e3eff4;
  -webkit-box-shadow: 0px 13px 24px -8px rgba(0, 0, 0, 0.26);
  -moz-box-shadow: 0px 13px 24px -8px rgba(0, 0, 0, 0.26);
  box-shadow: 0px 13px 24px -8px rgba(0, 0, 0, 0.26);

  strong {
    color: #0c5c75;
  }
`;

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`;

export const MarkAllButton = styled.button`
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: transparent;
  border: 2px solid #0c5c75;
  color: #0c5c75;
  transition: background 0.2s ease, opacity 0.2s ease;

  &:hover:not(:disabled) {
    background: ${rgba('#0c5c75', 0.1)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 32px;
  background: #e3eff4;
  border-radius: 16px;
  min-width: 380px;
  color: #0c5c75;
  box-shadow: -5px 10px 30px ${rgba('#0c5c75', 0.15)};

  @media (max-width: 480px) {
    min-width: auto;
    padding: 24px;
  }
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.4rem;
  color: #0c5c75;
`;

export const ModalMessage = styled.p`
  margin: 0;
  color: #094457;
  line-height: 1.5;
  white-space: pre-line;
`;

export const ModalMeta = styled.small`
  color: #4a5c64;
  font-weight: 500;
`;

export const ModalTimestamp = styled.small`
  color: #0c5c75;
  font-weight: 600;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const baseButton = `
  border-radius: 8px;
  padding: 10px 16px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: background 0.2s ease, color 0.2s ease, opacity 0.2s ease;
  min-width: 140px;
`;

export const SecondaryButton = styled.button`
  ${baseButton}
  background: transparent;
  border: 2px solid #0c5c75;
  color: #0c5c75;

  &:hover:not(:disabled) {
    background: ${rgba('#0c5c75', 0.1)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled.button`
  ${baseButton}
  background: #0c5c75;
  border: none;
  color: #fff;

  &:hover:not(:disabled) {
    background: ${shade(0.12, '#0c5c75')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
